module.exports = __webpack_public_path__ + "static2023-4-17/img/is_vip.a844a292.png";